var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"w-form__error",class:{'w-form__error--is-static':_vm.isStatic}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }